module.exports = __webpack_public_path__ + "static/media/14UNEP7.5b5665d8.jpg";